import { render } from "./Swatch.vue?vue&type=template&id=cf5de424&scoped=true"
import script from "./Swatch.vue?vue&type=script&lang=js"
export * from "./Swatch.vue?vue&type=script&lang=js"

import "./Swatch.vue?vue&type=style&index=0&id=cf5de424&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5de424"]])

export default __exports__